module.exports = __webpack_public_path__ + "media/images/mypage/icon/green-pale/ico_q&a-1022410c7a8d50487b417dab6f966e48.svg";